import { render, staticRenderFns } from "./VrstaSkupaDetails.vue?vue&type=template&id=0b96687b&scoped=true&"
import script from "./VrstaSkupaDetails.vue?vue&type=script&lang=js&"
export * from "./VrstaSkupaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96687b",
  null
  
)

export default component.exports